export default __webpack_public_path__ + "static/media/sally_bell.55173414.jpg";